import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "app-dialog-confirmar",
    templateUrl: "./dialog-confirmar.component.html",
    styleUrls: ["./dialog-confirmar.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogConfirmarComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DialogConfirmarComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {}
}
